export const calculateFloorPlate = (
  buildingSize: number | undefined | null,
  stories: number | undefined | null,
): number | undefined => {
  if (!buildingSize || !stories) return undefined;
  return Math.floor(buildingSize / stories);
};
